import { H3 } from '@berlitz/globals'
import EmptyState from '@components/EmptyState'
import { ProgramStudentInfo } from '@interfaces/Student'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const NotEnoughLessonsRemaining: React.FC<{
  isModal?: boolean
  isRebook?: boolean
  NoOfLessons?: number
  withViewCaseBtn?: boolean
} & (ProgramStudentInfo | {})> = ({
  LessonsRemaining,
  LessonsPerSession,
  isModal,
  isRebook,
  NoOfLessons = 0,
  withViewCaseBtn,
}) => (
  <EmptyState
    customHeading={
      <>
        <H3 disableMargin={isModal && isRebook}>
          {isRebook ? (
            <FormattedMessage
              id="lessons-remaining-for-rebooking"
              defaultMessage="You have {LessonsRemaining, plural, =0 {0 lessons} one {# lesson} other {# lessons}} remaining to be re-booked."
              values={{
                LessonsRemaining: NoOfLessons,
              }}
            />
          ) : (
            <FormattedMessage
              id="lessons-remaining-for-booking"
              defaultMessage="You have {LessonsRemaining, plural, =0 {0 lessons} one {# lesson} other {# lessons}} remaining to be booked."
              values={{
                LessonsRemaining,
              }}
            />
          )}
        </H3>
        <H3 disableMargin={isModal && isRebook}>
          <FormattedMessage
            id="lessons-per-session-for-booking"
            defaultMessage="However a minimum of {LessonsPerSession, plural, =0 {0 lessons} one {# lesson} other {# lessons}} is required when booking."
            values={{
              LessonsPerSession,
            }}
          />
        </H3>
      </>
    }
    bodyTxt={
      isRebook
        ? 'Please contact support for help with rescheduling your booking.'
        : 'We have raised a case on your behalf with your learning center.'
    }
    img="/images/events.svg"
    linkUrl="/support/requests"
    btnTxt="View case"
    top="md"
    isModal={isModal}
    withViewCaseBtn={withViewCaseBtn}
  />
)

export default NotEnoughLessonsRemaining
